

















import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { TipSubjectType } from "@scrile/api-provider/dist/api/TipProvider";
import TipController from "@/components/TipController";
import PostTippingModal from "./components/PostTippingModal.vue";

export default defineComponent({
  name: "PostTipping",
  components: { TipController, PostTippingModal },
  props: {
    feedId: { type: String, required: true },
    subjectType: { type: String as PropType<TipSubjectType>, required: false, default: TipSubjectType.CONTENT_SET },
  },
  setup(props) {
    const success = ref(false);

    const tipSubject = computed(() => {
      return { subjectId: props.feedId, subjectType: props.subjectType };
    });
    const setSuccess = () => {
      success.value = true;
    };
    return {
      tipSubject,
      success,
      setSuccess,
    };
  },
});
